import { ColDef } from 'ag-grid-community';

import { BomButtonCell } from './cells';

export const getColumnDefs = (onBomButtonClick?: (partBomId: number) => void): ColDef[] => [
  {
    headerName: '',
    field: 'select',
    width: 30,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    pinned: 'left',
  },
  {
    headerName: '',
    field: 'line',
    width: 30,
  },
  {
    headerName: 'Avail Loc Qty',
    field: 'availLocQty',
    width: 100,
  },
  {
    headerName: 'Quantity',
    field: 'quantity',
    width: 100,
  },
  {
    headerName: 'Part Type',
    field: 'partType',
    width: 80,
  },
  {
    headerName: 'Cust Line #',
    field: 'custLine',
    width: 90,
  },
  {
    headerName: 'Mfr Part #',
    field: 'mfrPartNumber',
    width: 100,
  },
  {
    headerName: 'MFG/Brand',
    field: 'mfgBrand',
    width: 100,
  },
  {
    headerName: 'Supplier PO Number #',
    field: 'supplierPoNumber',
    width: 150,
  },
  {
    headerName: 'Product Description',
    field: 'description',
    width: 200,
    flex: 1,
  },
  {
    headerName: 'Customer Part Number',
    field: 'customerPartNumber',
    width: 150,
  },
  {
    headerName: 'Ship Type',
    field: 'shipType',
    width: 90,
  },
  {
    headerName: '',
    field: 'actions',
    width: 100,
    resizable: false,
    sortable: false,
    filter: false,
    cellRenderer: BomButtonCell,
    cellRendererParams: {
      onClick: onBomButtonClick,
    },
  },
];
